import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fire",
  "use": "fire-usage",
  "viewBox": "0 0 22 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 28\" id=\"fire\"><path fill=\"currentColor\" d=\"M22 26.5v1c0 .266-.234.5-.5.5H.5a.514.514 0 01-.5-.5v-1c0-.266.234-.5.5-.5h21c.266 0 .5.234.5.5zM18 10c0 5.984-7 6.516-7 10.5 0 1.094.547 2.547 1.047 3.5l-.063-.016L12 24c-4.312-1.984-8-4.719-8-10 0-5.984 7-6.516 7-10.5C11 2.406 10.453.953 9.969 0l.047.016L10 0c4.312 1.984 8 4.719 8 10z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol